export type LabelPosition = 'none' | 'left' | 'top' | 'right'
export type TitleAlign = 'start' | 'center' | 'end'

function isLabelPosition(value: string): value is LabelPosition {
  return value === 'none' || value === 'left' || value === 'top' || value === 'right'
}

function isTitleAlign(value: string): value is TitleAlign {
  return value === 'start' || value === 'center' || value === 'end'
}

export function resolveLabelPosition(node: { labelPosition?: string }): LabelPosition {
  const raw = node.labelPosition
  return raw && isLabelPosition(raw) ? raw : 'left'
}

export function resolveTitleAlign(node: { titleAlign?: string }): TitleAlign {
  const raw = node.titleAlign
  return raw && isTitleAlign(raw) ? raw : 'start'
}

export function resolveTitleVerticalAlign(node: { titleVerticalAlign?: string }): TitleAlign {
  const raw = node.titleVerticalAlign
  return raw && isTitleAlign(raw) ? raw : 'center'
}

export function resolveLabelColumnWidthPx(
  groupWidth: number | 'auto' | undefined,
  fieldWidth: number | 'auto' | undefined,
  autoPx: number,
): number {
  if (typeof fieldWidth === 'number') return fieldWidth
  if (typeof groupWidth === 'number') return groupWidth
  return Math.min(220, Math.max(96, autoPx))
}
